import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { Bank, BankFilters } from '../../../../app/models/Bank';
import { ExpenseType, ExpenseTypeFilters } from '../../../../app/models/ExpenseType';
import ExpenseTypeSwitchChange from '../ExpenseTypeSwitchChange';
import { Account } from '../../../../app/models/Account';

interface Props {
    expenseTypes: ExpenseType[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: ExpenseTypeFilters;
    setFilter: (filter: ExpenseTypeFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    is_system: boolean;
}

const ExpenseTypeDataTable = ({
    expenseTypes,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess,
    is_system
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: Bank, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: Bank, index: any, column: any) => <span className="">{row.name}</span>
        },
        {
            name: 'Cuenta contable',
            selector: (row: any) => row?.account_id,
            sortable: true,
            sortField: 'account',
            cell: (row: any, index: any, column: any) => {
                return row.account;
            }
        },

        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            omit: is_system,
            cell: (row: Bank, index: any, column: any) => (
                <ExpenseTypeSwitchChange
                    checkValue={row.is_active ?? true}
                    expenseTypeId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: Bank, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* <BankFilters filter={filter} setFilter={setFilter} /> */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={expenseTypes}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default ExpenseTypeDataTable;
